module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAXCAYAAAALHW+jAAABR0lEQVQ4jWP8DwQMVARM1DSMaAPzSuoZ8orriDKQhZCCR4+fMZw6fZ7hPxCC2HKyUnjVMxIKw75Jsxl+/PzJAFLGxcnBUJibit8F//GAP3/+/Ld2Cvx/6869/7du3wOzQWL4AN4wPHj4BIOMtASDqrIig6qKIoO0lDjDwSMn8ToQr4Gr121hCA3ygfNBbJAYWV5+8fL1fxNrr/9fv36Di4HYILGXr16T7uV1G7czeLg5MHBxccLFQGx3Vweg3A6cDsQay//+/WNw9YliePL0OVZNsjJSDLs2L2VgYsLiHmzOPnbizH+f4IT/QIMx5EBi3kHx/4+fPEu8l1ev2wqOAEZGRkwvAcXC8EQOwYRNKkB14datDAySkiBnEIdBakF6kAFKABgYgJxLGgbpQQKoBm7Z8v+/hATxhoHUgvQgARqH4aiBg8JAACaumRIzrLg6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/yshhtb1-1.png
// module id = 776
// module chunks = 0